import React from 'react';

import NextImage from 'next/image';
import { usePathname } from 'next/navigation';

import { useAnalytics } from '../../../../../../contexts/AnalyticsContext/AnalyticsContext';
import { trackNavigation } from '../../../../../../helpers/analytics';
import { trackEvent } from '../../../../../../helpers/analytics/trackEvent';
import { ExternalLink } from '../../../../../Clickables/ExternalLink/ExternalLink';
import { InternalLink } from '../../../../../Clickables/InternalLink/InternalLink';
import { Heading } from '../../../../../Heading/Heading';
import activeLinkIcon from '../../../assets/activeLinkIcon.svg';
import { INavLinkItem, MAIN_NAV_LINKS } from '../../../constants/navlinks';

interface IProps {
  onExpandedChange: (value: boolean) => void;
}

export const PrimaryDropDownLinks = ({ onExpandedChange }: IProps) => {
  const pathname = usePathname();
  const { currentPage } = useAnalytics();

  return (
    <ul
      className="border-twilight mx-6 mt-4 mb-0 border-b sm:mx-11 sm:mt-6 md:hidden"
      data-testid="PrimaryDropDownLinks"
    >
      {MAIN_NAV_LINKS.map(({ path, title, type, id }: INavLinkItem) => {
        const isActiveTab = path === pathname;

        return (
          <li
            className="mb-4 sm:mb-6 md:mb-4"
            key={`dropdown-secondary-nav-link-${id}`}
            data-testid="PrimaryDropDownLinks item"
          >
            {type === 'external' ? (
              <ExternalLink
                href={path}
                variant="textNone"
                onClick={() => {
                  onExpandedChange(false);
                  trackNavigation({ path, currentPage });
                  void trackEvent({
                    name: 'mykiss_hamburger_clicked',
                    properties: { action: 'navigate', source: currentPage },
                  });
                }}
                data-testid={`dropdown-secondary-nav-link-${id}`}
              >
                <Heading
                  withDefaults={false}
                  variant="md"
                  color={isActiveTab ? 'navHighlight' : 'dark'}
                  className="font-heading hover:text-trench flex items-start"
                  as="span"
                >
                  <NextImage
                    alt="Active Link Icon"
                    width={6}
                    height={20}
                    className={`my-auto mr-[18px] -ml-6 sm:mr-[38px] sm:-ml-11 ${
                      isActiveTab ? 'block' : 'hidden'
                    }`}
                    src={activeLinkIcon}
                  />
                  {title}
                </Heading>
              </ExternalLink>
            ) : (
              <>
                <InternalLink
                  to={path}
                  variant="textNone"
                  onClick={() => {
                    onExpandedChange(false);
                    trackNavigation({ path, currentPage });
                    void trackEvent({
                      name: 'mykiss_hamburger_clicked',
                      properties: { action: 'navigate', source: currentPage },
                    });
                  }}
                  data-testid={`dropdown-secondary-nav-link-${id}`}
                >
                  <Heading
                    withDefaults={false}
                    variant="md"
                    color={isActiveTab ? 'navHighlight' : 'dark'}
                    className="font-heading hover:text-trench flex items-start"
                    as="span"
                  >
                    <NextImage
                      alt="Active Link Icon"
                      width={6}
                      height={20}
                      className={`my-auto mr-[18px] -ml-6 sm:mr-[38px] sm:-ml-11 ${
                        isActiveTab ? 'block' : 'hidden'
                      }`}
                      src={activeLinkIcon}
                    />
                    {title}
                  </Heading>
                </InternalLink>
              </>
            )}
          </li>
        );
      })}
    </ul>
  );
};
